import type { To } from "react-router-dom";

/**
 * React Router resolves `to="#"` / `to="#!"` with an undefined pathname and can throw
 * (e.g. "Cannot read properties of undefined (reading 'endsWith')") on re-render.
 * Hash-only targets stay on the current path so pagination/action links do not navigate away.
 */
const HASH_ONLY = new Set(["#", "#!", "/#", "/#!"]);

export function safeRouterTo(link: string | undefined | null, fallback = "/"): string {
  if (!link) {
    return fallback;
  }
  const trimmed = link.trim();
  if (!trimmed || HASH_ONLY.has(trimmed) || trimmed.startsWith("#")) {
    return fallback;
  }
  return trimmed;
}

export function coerceRouterTo(to: To | undefined | null, fallback = "/"): To {
  if (to == null || to === "") {
    return fallback;
  }
  if (typeof to === "string") {
    return safeRouterTo(to, fallback);
  }
  const pathname = to.pathname;
  if (
    pathname == null ||
    pathname === "" ||
    HASH_ONLY.has(pathname) ||
    pathname.startsWith("#")
  ) {
    return { ...to, pathname: fallback };
  }
  return to;
}
